import * as React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
import { useCurrentUser } from 'hooks/useCurrentUser'
// icons
import { VerginaSunIcon } from 'components/UI/Icons'
// themes
import { colors } from 'themes'
// views
import { Button, AiButtonsWrapper } from './views'
// constants
import { AI_SUPPORTED_FIELD_TYPES } from 'constants/ai'
// types
import { Modals } from 'constants/modals'
import { FieldType, IField } from 'types/graphql'

interface Props {
  field: IField
  isTable?: boolean
}

const AiControlButton: React.FC<Props> = ({ field, isTable }) => {
  const {
    permissionsFromSecurityGroups: { aiEnableUsage }
  } = useCurrentUser()

  const { showModal: showMatrixResultModal } = useShowModal({ modalType: Modals.AI_MATRIX_VALUE_MODAL })
  const { showModal: showPromptModal } = useShowModal({ modalType: Modals.AI_FIELD_VALUE_MODAL })

  const onClick = () => {
    if (field.fieldType === FieldType.RiskMatrix) {
      showMatrixResultModal({ field })
      return
    }
    showPromptModal({ field })
  }

  if (!aiEnableUsage || !field?.includeInAiContext || !AI_SUPPORTED_FIELD_TYPES.includes(field?.fieldType)) {
    return null
  }

  return (
    <AiButtonsWrapper $isTable={isTable}>
      <Button onClick={onClick}>
        <VerginaSunIcon sx={{color: colors.blue500}} />
      </Button>
    </AiButtonsWrapper>
  )
}
export default AiControlButton
